/** Labels mirror the backend enums' label(). An unrecognised value renders
 *  verbatim, so a member added server-side is shown rather than hidden. */

const AMENDMENT_TYPE_LABELS: Record<string, string> = {
    contact_details: 'Contact details',
    name: 'Name',
};

const REASON_LABELS: Record<string, string> = {
    marriage: 'Marriage',
    divorce: 'Divorce',
    deed_poll: 'Deed poll',
    correction: 'Correction',
};

const REQUESTER_LABELS: Record<string, string> = {
    holder: 'Plan holder',
    authorised_contact: 'Authorised contact',
    dealer: 'Dealer',
    power_of_attorney: 'Power of attorney',
    other: 'Other',
};

const EVIDENCE_LABELS: Record<string, string> = {
    marriage_certificate: 'Marriage certificate',
    decree_absolute: 'Decree absolute',
    deed_poll: 'Deed poll',
    passport: 'Passport',
    driving_licence: 'Driving licence',
    dealer_confirmation: 'Dealer confirmation',
    other: 'Other',
};

const FIELD_LABELS: Record<string, string> = {
    title: 'Title',
    forename: 'Forename',
    surname: 'Surname',
    address_line_1: 'Address Line 1',
    address_line_2: 'Address Line 2',
    city: 'City',
    postcode: 'Postcode',
    email: 'Email',
    phone: 'Phone',
    mobile_phone: 'Mobile Phone',
    business_name: 'Business Name',
    vat_number: 'VAT Number',
};

const labelFrom = (labels: Record<string, string>, value: string): string =>
    Object.hasOwn(labels, value) ? labels[value] : value;

export const amendmentTypeLabel = (value: string): string => labelFrom(AMENDMENT_TYPE_LABELS, value);
export const nameChangeReasonLabel = (value: string): string => labelFrom(REASON_LABELS, value);
export const requesterTypeLabel = (value: string): string => labelFrom(REQUESTER_LABELS, value);
export const evidenceTypeLabel = (value: string): string => labelFrom(EVIDENCE_LABELS, value);
export const amendmentFieldLabel = (column: string): string => labelFrom(FIELD_LABELS, column);

export const toOptions = <T extends string>(
    values: readonly T[],
    label: (value: string) => string,
): Array<{ value: T; label: string }> => values.map((value) => ({ value, label: label(value) }));

/** An unparseable timestamp renders as received rather than as "Invalid Date". */
export const formatRecordedAt = (value: string): string => {
    const parsed = new Date(value);

    return Number.isNaN(parsed.getTime())
        ? value
        : parsed.toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' });
};
